import type { ReactNode } from "react";
import { useConfig } from "../../state/config-context";

export function Pagination({
  hasPrev,
  hasNext,
  onPrev,
  onNext,
  busy = false,
}: {
  hasPrev: boolean;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  busy?: boolean;
}): ReactNode {
  const { t } = useConfig();
  if (!hasPrev && !hasNext) {
    return null;
  }
  return (
    <nav className="pagination" aria-label={t("crm.common.pagination")}>
      <button
        type="button"
        className="btn btn--ghost"
        onClick={onPrev}
        disabled={!hasPrev || busy}
      >
        {t("crm.common.previous")}
      </button>
      <button
        type="button"
        className="btn btn--ghost"
        onClick={onNext}
        disabled={!hasNext || busy}
      >
        {t("crm.common.next")}
      </button>
    </nav>
  );
}
